var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2892 49.9681H50.4559C51.0392 49.9681 51.4767 49.7007 51.7684 49.166C52.0601 48.6313 52.0114 48.1209 51.6226 47.6348L43.6017 36.916C43.3101 36.5271 42.9212 36.3327 42.4351 36.3327C41.9489 36.3327 41.5601 36.5271 41.2684 36.916L33.6851 47.0514L28.2892 39.8327C27.9976 39.4438 27.6087 39.2493 27.1226 39.2493C26.6364 39.2493 26.2476 39.4438 25.9559 39.8327L20.1226 47.6348C19.7337 48.1209 19.6851 48.6313 19.9767 49.166C20.2684 49.7007 20.7059 49.9681 21.2892 49.9681ZM15.4559 61.6348C13.8517 61.6348 12.478 61.0641 11.3346 59.9227C10.1933 58.7794 9.62256 57.4056 9.62256 55.8014V14.9681C9.62256 13.3639 10.1933 11.9902 11.3346 10.8468C12.478 9.70546 13.8517 9.13477 15.4559 9.13477H56.2892C57.8934 9.13477 59.2671 9.70546 60.4105 10.8468C61.5519 11.9902 62.1226 13.3639 62.1226 14.9681V55.8014C62.1226 57.4056 61.5519 58.7794 60.4105 59.9227C59.2671 61.0641 57.8934 61.6348 56.2892 61.6348H15.4559ZM15.4559 55.8014H56.2892V14.9681H15.4559V55.8014Z",
    fill: "#8D78FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.52667559582441fce679921ceaf1568a.svg";
export { ForwardRef as ReactComponent };